import React, { ReactNode } from "react";
import { isFriendlyUI } from "../../themes/forumTheme";
import type { Placement as PopperPlacementType } from "popper.js"
import HoverOver from "../common/HoverOver";
import SequencesSummary from "./SequencesSummary";

export const SequencesTooltip = ({
  sequence,
  showAuthor = true,
  allowOverflow,
  placement,
  children,
}: {
  sequence: SequenceSummaryFragment|null,
  showAuthor?: boolean,
  allowOverflow?: boolean,
  placement?: PopperPlacementType,
  children?: ReactNode,
}) => {
  return (
    <HoverOver
      title={
        <SequencesSummary
          sequence={sequence}
          showAuthor={showAuthor}
          maxPosts={isFriendlyUI() ? 8 : undefined}
        />
      }
      tooltip={false}
      inlineBlock={false}
      flip={!allowOverflow}
      placement={placement}
      clickable
    >
      {children}
    </HoverOver>
  );
}

export default SequencesTooltip;
